import { getSissiInvoicingUrl } from "../config/server";
import {
  findInvoicingSystemData,
  INVOICING_SYSTEM_MODELS,
} from "./invoicing-system-data";

export async function getServices() {
  const url = `${getSissiInvoicingUrl()}/services?$limit=1000`;
  const res = await fetch(url, {
    credentials: "include",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "x-company": window.currentCompanyId,
    },
  });
  if (res.status !== 200) {
    throw await res.json();
  }
  return await res.json();
}

export async function saveService(data) {
  const url = `${getSissiInvoicingUrl()}/services`;
  const res = await fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "x-company": window.currentCompanyId,
    },
  });
  if (res.status !== 200 && res.status !== 201) {
    throw await res.json();
  }
  return await res.json();
}

/**
 * Fetches the services defined in the currently configured Odoo instance,
 * flagging the ones that have already been imported (matched by
 * `invoicingSystemId` against the Odoo product id).
 *
 * @returns {Promise<Array>} The Odoo services, each with an `imported` flag.
 */
export async function getInvoicingSystemServicesForImport() {
  const [existingServices, invoicingSystemServices] = await Promise.all([
    getServices(),
    findInvoicingSystemData(INVOICING_SYSTEM_MODELS.SERVICE),
  ]);

  const importedInvoicingSystemIds = new Set(
    existingServices.data
      .map((service) => service.invoicingSystemId)
      .filter(
        (invoicingSystemId) =>
          invoicingSystemId !== undefined && invoicingSystemId !== null,
      ),
  );

  return invoicingSystemServices.data.map((invoicingSystemService) => ({
    ...invoicingSystemService,
    imported: importedInvoicingSystemIds.has(invoicingSystemService.id),
  }));
}

/**
 * Creates local services from the selected Odoo services.
 *
 * @param {Array} invoicingSystemServices - Services selected from the Odoo instance.
 * @returns {Promise<Array>} The newly created services.
 */
export async function importServices(invoicingSystemServices) {
  return saveService(
    invoicingSystemServices.map((invoicingSystemService) => ({
      name: invoicingSystemService.name,
      description: invoicingSystemService.description || "",
      invoicingSystemId: invoicingSystemService.id,
      billingFrequency: "ONE_TIME",
      isRentalService: false,
      isServiceFee: false,
      isServiceFeeReducedTax: false,
      isFinalCleaningService: false,
      isCityTax: false,
    })),
  );
}

export async function saveServices(data) {
  const url = `${getSissiInvoicingUrl()}/services`;
  const res = await fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "x-service-method": "bulkUpdate",
      "x-company": window.currentCompanyId,
    },
  });
  if (res.status !== 200 && res.status !== 201) {
    throw await res.json();
  }
  return await res.json();
}
